import { FC, useContext } from "react";
import { useNavigate } from "react-router-dom";

import {
  Affix,
  Button,
  Image,
  Layout,
  theme,
  message,
} from "antd";
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
} from "@ant-design/icons";

import { Searchbar, UserAvatar } from "./components";

import { LogoWhite } from "../../../../../assets";
import { AuthContext, UIContext } from "../../../../contexts";
import { USER_MENU_ITEMS } from "./utils";
import { MenuOption, UserInformation } from "../../../../interfaces";

import "./index.css";
import { Notifications } from "./components/Notifications";
import { CompanyData } from "../../../../interfaces/services/company-data-enum";
import { useIsMobile } from "../../../../hooks/MobileOrDesktop";

interface CustomHeaderProps {
  menus: Array<MenuOption>;
}

export const CustomHeader: FC<CustomHeaderProps> = ({ menus }) => {
  const authContext = useContext(AuthContext);

  const { Header } = Layout;
  const {
    token: { colorPrimary, colorWhite },
  } = theme.useToken();
  const resp = authContext.getUserInfo() as UserInformation | null;
  let hasIntermediary = false;
  hasIntermediary = resp?.intermediarioSecundario != null;
  const { isSideMenuOpen, isSiderCollapsed, toogleSideMenu, toggleSiderCollapsed } = useContext(UIContext);
  const isMobile = useIsMobile();
  const navigate = useNavigate();

  const navigateToHome = () => {
    if (hasIntermediary) {
      const homePath = menus.find((el) => el.descripcion === "Home")?.path;
      navigate(homePath ?? "/home");

      return;
    }

    const messageWarning = "Debe seleccionar un intermediario.";
    message.warning(messageWarning);
  };

  return (
    <Affix>
      <Header
        className="custom-header"
        style={{
          backgroundColor: colorPrimary,
        }}
      >
        <div className="image-logo-container">
          <Image
            src={LogoWhite}
            width={195}
            height={"auto"}
            preview={false}
            alt={CompanyData.COMPANY_NAME}
            title={CompanyData.COMPANY_NAME}
            onClick={navigateToHome}
          />
        </div>

        {hasIntermediary && (
        <Button
          type="text"
          icon={
            isMobile
            ? (
              isSideMenuOpen
                ? <MenuUnfoldOutlined style={{ color: colorWhite }} />
                : <MenuFoldOutlined style={{ color: colorWhite }} />
            )
            : (
              isSiderCollapsed
                ? <MenuUnfoldOutlined style={{ color: colorWhite }} />
                : <MenuFoldOutlined style={{ color: colorWhite }} />
            )
        }
          onClick={isMobile ? toogleSideMenu : toggleSiderCollapsed}
          className="header-buttons"
        />
      )}

        <Searchbar menus={menus} />

        <div style={{ flex: 1 }} />

        <Notifications />

        <UserAvatar items={USER_MENU_ITEMS} />
      </Header>
    </Affix>
  );
};
